"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: var(--font-size-medium);\n  font-weight: bold;\n  color: var(--color-primary);\n\n  background-color: var(--color-primary-light-1);\n  border: 1px solid var(--color-primary-light-2);\n  margin: 0.5rem;\n  border-radius: 3px;\n\n  text-align: center;\n  padding: 0.75rem 1.25rem;\n  display: inline-block;\n\n  cursor: ", ";\n\n  transition: transform 0.2s, box-shadow 0.2s;\n\n  &:hover {\n    transform: ", ";\n    box-shadow: ", ";\n  }\n\n  &:active {\n    transform: translateY(0);\n    box-shadow: initial;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.StyledSpan = styled_components_1.default.span(_templateObject(), function (_ref) {
  var clickable = _ref.clickable;
  return clickable && 'pointer';
}, function (_ref2) {
  var clickable = _ref2.clickable;
  return clickable && 'translateY(-5%)';
}, function (_ref3) {
  var clickable = _ref3.clickable;
  return clickable && 'var(--box-shadow-node)';
});